import {isPlatformBrowser, NgClass, NgForOf, NgIf, NgOptimizedImage, SlicePipe} from '@angular/common';
import {Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges} from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { FilterItemsComponent } from '../filter-items/filter-items.component';
import { AddNewColumnComponent } from '../add-new-column/add-new-column.component';
import { TlPagination } from 'src/app/interfaces/general-interfaces';
import {Column, DeleteModalText, ListItem, Row} from 'src/app/services/http-services/lists/lists-http-intterfaces';
import { ListsHttpService } from 'src/app/services/http-services/lists/lists-http.service';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ConfirmModalComponent } from 'src/app/shared-components/confirm-modal/confirm-modal.component';
import { ItemRowComponent } from '../item-row/item-row.component';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { ItemsHttpService } from 'src/app/services/http-services/items/items-http.service';
import { ListsHelperService } from 'src/app/services/helpers/lists-helper.service';
import { AuthenticationHelperService } from 'src/app/services/helpers/authentication-helper.service';
import { ClickedOutsideModule } from 'src/app/directives/clicked-outside/clicked-outside.module';
import { CopyItemModalComponent } from '../copy-item-modal/copy-item-modal.component';
import { CopyToastNotificationComponent } from 'src/app/shared-components/copy-toast-notification/copy-toast-notification.component';
import { TranslateModule } from '@ngx-translate/core';
import {catchError, finalize, switchMap} from 'rxjs/operators';
import {of, throwError, timer} from 'rxjs';
import {TrimToLengthPipe} from "../../../../../pipes/trim/trim-to-length-pipe";

@Component({
  selector: 'app-items',
  standalone: true,
  imports: [
    NgForOf,
    RouterModule,
    NgClass,
    NgIf,
    FilterItemsComponent,
    AddNewColumnComponent,
    RouterModule,
    FormsModule,
    ConfirmModalComponent,
    ItemRowComponent,
    DragDropModule,
    SlicePipe,
    ClickedOutsideModule,
    CopyItemModalComponent,
    CopyToastNotificationComponent,
    TranslateModule,
    NgOptimizedImage,
    TrimToLengthPipe
  ],
  templateUrl: './items.component.html',
})
export class ItemsComponent implements OnInit, OnChanges {
  listId = 0;
  PAGES_AND_PATHS = PAGES_AND_PATHS;
  itemsView = '';
  isFilterModalOpen = false;
  isAddNewColumnOpen = false;
  pageNum = 1;
  rows: any[] = [];
  @Input() items: ListItem[] = [];
  @Input() user_id = 0;
  pagination!: TlPagination;
  searchTerm = '';
  @Input() columns: Column[] = [];
  isDeleteModalOpen = false;
  deleteModalText: DeleteModalText = { title: '', description: '', button: '' };
  selectedColumn: Column | null = null;
  addNewRow = false;
  @Output() searchTermChanged = new EventEmitter<string>();
  @Input() filters = { sort: 'asc', id: 0 };
  loggedUser: any;
  isCopyModalOpen = false;
  isCopyDropdownOpen = false;
  selectedItem: ListItem | null = null;
  url = '';
  isOpenToastOpen = false;
  selectedListAndItem: any;
  isFocused = false;
  @Output() openColumnIdeas = new EventEmitter<boolean>();
  @Output() errorAutopopulate = new EventEmitter<boolean>();
  @Output() areItemsLoading = new EventEmitter<boolean>();
  @Output() openPublicListModal = new EventEmitter<void>();

  constructor(
    private listsHttpService: ListsHttpService,
    private actRoute: ActivatedRoute,
    private toastService: ToastrService,
    private itemsHttpService: ItemsHttpService,
    private listsHelperService: ListsHelperService,
    private authenticationHelperService: AuthenticationHelperService,
    @Inject(PLATFORM_ID) private platformId: string,
  ) { }

  ngOnInit(): void {
    // this.historyState = history.state;
    // if (this.historyState.list || this.historyState.item) {
    //   this.selectedListAndItem = { list: this.historyState.list, item: this.historyState.item };
    //   this.isOpenToastOpen = true;
    //   window.history.replaceState({}, '', this.router.url);
    // }
    if (isPlatformBrowser(this.platformId)) {
      this.loggedUser = this.authenticationHelperService.getUserData;
    }
    this.actRoute.paramMap.subscribe(params => {
      this.listId = Number(params.get('id') || '');
      this.itemsView = params.get('view') as string;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.rows = this.items.map(x => x.lyst_item_attributes);
  }

  addNewItem(): void {
    if (this.loggedUser) {
      this.itemsView = 'table';
      this.itemsHttpService.createNewItem({ lyst_id: this.listId }).then((response: any) => {
        this.addNewRow = true;
        this.listsHelperService.refreshPage(true);
      });
    } else {
      this.openPublicListModal.emit();
    }
  }

  onSearchChange(event: any): void {
    this.searchTerm = event.target.value;
    this.pageNum = 1;
    this.searchTermChanged.emit(this.searchTerm);
  }

  resetSearch(): void {
    this.searchTerm = '';
    this.searchTermChanged.emit('');
  }

  handleColumnName(reqObj: { name: string }): void {
    if (this.loggedUser) {
      if (this.selectedColumn && this.isAddNewColumnOpen) {
        this.updateColumn(this.selectedColumn.id, reqObj);
      } else {
        this.addNewColumn(reqObj);
      }
    } else {
      this.openPublicListModal.emit();
    }
  }

  addNewColumn(reqObj: { name: string }): void {
    if (this.loggedUser) {
      this.listsHttpService.postListColumn(reqObj, this.listId).then((response: any) => {
        this.toastService.success(response.message);
        this.isAddNewColumnOpen = false;
        this.listsHelperService.refreshPage(true);
      });
    } else {
      this.openPublicListModal.emit();
    }
  }

  deleteColumn(id: number | undefined): void {
    if (this.loggedUser) {
      this.isDeleteModalOpen = false;
      this.listsHttpService.deleteListColumn(id).then((response: any) => {
        this.toastService.success(response.message);
        this.selectedColumn = null;
        this.listsHelperService.refreshPage(true);
      });
    } else {
      this.openPublicListModal.emit();
    }
  }

  updateColumn(id: number, reqObj: { name: string }): void {
    if (this.loggedUser) {
      this.isAddNewColumnOpen = false;
      this.listsHttpService.updateListColumn(id, reqObj).then((response: any) => {
        this.toastService.success(response.message);
        this.listsHelperService.refreshPage(true);
      });
    } else {
      this.openPublicListModal.emit();
    }
  }

  openDeleteColumnModal(column: Column): void {
    if (this.loggedUser) {
      this.isDeleteModalOpen = true;
      this.selectedColumn = column;
      this.deleteModalText.title = 'Delete column?';
      this.deleteModalText.description = 'Are you sure you wish to delete this column? This action cannot be undone.';
      this.deleteModalText.button = 'GENERAL.delete';
    } else {
      this.openPublicListModal.emit();
    }
  }

  openUpdateColumnModal(column: Column): any {
    if (this.loggedUser) {
      if (this.loggedUser.id !== this.user_id) {
        return;
      }
      this.selectedColumn = column;
      this.isAddNewColumnOpen = true;
    } else {
      this.openPublicListModal.emit();
    }
  }

  takeAction(): void {
    if (this.loggedUser) {
    this.deleteColumn(this.selectedColumn?.id);
    } else {
      this.openPublicListModal.emit();
    }
  }

  drop(event: CdkDragDrop<any[]>): void {
    moveItemInArray(this.items, event.previousIndex, event.currentIndex);
    const reorderedList = this.items.map((item, index) => ({
      id: item.id,
      order_value: index + 1
    }));

    const reqObj = { order: reorderedList };
    this.listsHttpService.reorderListItems(this.listId, reqObj).then(() => {
    });
  }

  openCopyModal(selectedItem: ListItem | null, event: any): void {
    if (this.loggedUser) {
      this.isCopyDropdownOpen = true;
      event.stopPropagation();
      this.url = `/single-list/${selectedItem?.lyst_id}/cards`;
      this.selectedItem = selectedItem;
    } else {
      this.openPublicListModal.emit();
    }
  }

  closeCopyModal(): void {
    this.isOpenToastOpen = false;
  }

  autoPopulate(): void {
    const maxTime = 20000;
    const retryDelay = 500;
    const startTime = Date.now();
    let isComplete = false;
    this.areItemsLoading.emit(true);

    const autopopulateProcess: any = () => {
      return this.listsHttpService.autopopulateList(this.listId).pipe(
        switchMap((response: any) => {
          if (response.data.status === 100) {
            isComplete = true;
            this.listsHelperService.refreshPage(true);
            return of(null);
          }

          if (response.data.status === 200) {
            const elapsedTime = Date.now() - startTime;
            if (elapsedTime < maxTime) {
              return timer(retryDelay).pipe(
                switchMap(() => autopopulateProcess())
              );
            } else {
              throw new Error('Timeout: No 100 received within 20 seconds');
            }
          }

          if (response.data.status === 400) {
            isComplete = true;
            this.errorAutopopulate.emit(true);
            return throwError(() => new Error('Error in autopopulation (400)'));
          }

          return throwError(() => new Error('Unexpected status code'));
        }),
        catchError((err) => {
          this.errorAutopopulate.emit(true);
          return of(null);
        })
      );
    };

    autopopulateProcess()
      .pipe(
        finalize(() => {
          if (!isComplete) {
            this.errorAutopopulate.emit(true);
          }
          this.areItemsLoading.emit(false);
        })
      )
      .subscribe();
  }

  populateData(): void {
      this.areItemsLoading.emit(true);
    this.listsHttpService.populateMissingData(this.listId).subscribe({
      next: (response: any) => {
        if (response.code === 200) {
          this.areItemsLoading.emit(false);
          this.listsHelperService.refreshPage(true);
        } else if (response.code === 400) {
          this.areItemsLoading.emit(false);
          this.errorAutopopulate.emit(true);
          throw new Error('Error in autopopulation (400)');
        } else {
          this.areItemsLoading.emit(false);
          this.errorAutopopulate.emit(true);
        }
      },
      error: () => {
        this.areItemsLoading.emit(false);
        this.errorAutopopulate.emit(true);
      },
      complete: () => {
      }
    });

  }

  onFocus(): void {
    this.isFocused = true;
  }

  onBlur(): void {
    this.isFocused = false;
  }
}
